import React from 'react';

const MapLoading = () => {
  return (
    <div className="loading-container">
      <div className="loading loading--revolve">
        <div className="loading__ball"></div>
        <div className="loading__ball"></div>
        <div className="loading__ball"></div>
        <div className="loading__ball"></div>
      </div>
    </div>
  );
};

export default MapLoading;
